import React, { useState } from 'react'
import styles from './styles.module.css'

function Sizes ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const sizesToShow = isExpanded
    ? record.sizes
    : record.sizes?.slice(0, 3) || []

  return (
    <div className={styles.rawCategoriesContainer}>
      <h1 className={styles.rawCategoriesTitle}>Sizes</h1>

      <div className={styles.rawCategoriesList}>
        {sizesToShow.length > 0 ? (
          sizesToShow.map((category, index) => (
            <span key={index} className={styles.rawCategoriesItem}>
              {category}
            </span>
          ))
        ) : (
          <span className={styles.noRawCategories}>N/A</span>
        )}
      </div>

      {record.sizes && record.sizes.length > 3 && (
        <button className={styles.rawCategoriesButton} onClick={toggleExpand}>
          {isExpanded
            ? 'Show less'
            : `Expand all (${record.sizes.length})`}
        </button>
      )}
    </div>
  )
}

export default Sizes
